/**
 * Copyright © WarmHeart Intelligence Technology Group (Jiangsu) Co.,Ltd Company, Limited.
 * All Rights Reserved
 */
import url from "./conf";
import {post, tokenPost} from "./ajax";

const merchant = {
  /**
   *  AJAX-分页获取商户列表
   *  @param keys
   *  @param page
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  pageByFuzzy(keys,page, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.PAGE_BY_FUZZY,
      {
        keys: keys,
        pageIndex: page.pagination,
        pageSize: page.size,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-添加商户
   *  @param info
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  add(info, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_MERCHANT,
      {
        merchantName : info.name,
        merchantNum : info.num,
        contactName : info.contactName,
        mobileNo : info.mobileNo,
        merchantAddress : info.address
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-修改商户
   * @param info
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  modify(info, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.MODIFY_MERCHANT,
      {
        merchantName : info.name,
        merchantNum : info.num,
        contactName : info.contactName,
        mobileNo : info.mobileNo,
        merchantAddress : info.address,
        isStop: info.isStop,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-启用/停用商户
   * @param num
   * @param flag
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  stop(num, flag, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.STOP_MERCHANT,
      {
        num: num,
        flag: flag,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取商户详情
   * @param num
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  acquire(num, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ACQUIRE_MERCHANT,
      {
        num: num,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取门店列表
   * @param num
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listShop(num, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_SHOP_MERCHANT,
      {
        num: num,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-添加门店
   * @param num
   * @param shopId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addShop(num, shopId, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_SHOP_MERCHANT,
      {
        num: num,
        shopId: shopId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-删除门店
   * @param num
   * @param shopId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  deleteShop(num, shopId, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.DELETE_SHOP_MERCHANT,
      {
        num: num,
        shopId: shopId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
}

export default merchant;



// WEBPACK FOOTER //
// ./src/assets/ajax/ajax-merchant.js